module.exports = __webpack_public_path__ + "img/wsxx.89446453.png";